<template>
  <div>
    <v-row density="compact" class="mb-2">
      <v-col>
        <v-checkbox
          v-model="excludeUs"
          label="Exclude US stocks"
          density="compact"
          hide-details
        />
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="25"
      density="compact"
      :no-data-text="loading ? 'Loading...' : 'No data available.'"
    >
      <template #item.instrument_name="{ item }">
        <template v-if="item.instrument_name">
          <router-link v-if="item.perm_id_instrument_id" :to="'/global/instrument/' + item.perm_id_instrument_id">
            {{ item.instrument_name }}
          </router-link>
          <span v-else>{{ item.instrument_name }}</span>
        </template>
        <span v-else class="text-grey font-italic">
          <v-icon size="x-small" class="mr-1">mdi-lock</v-icon>Standard subscription required
        </span>
      </template>
      <template #item.total_market_value="{ item }">
        ${{ human_number(item.total_market_value) }}
      </template>
      <template #item.avg_pct_portfolio="{ item }">
        {{ percent(item.avg_pct_portfolio) }}
      </template>
      <template #item.total_change_value="{ item }">
        <span :class="item.total_change_value > 0 ? 'text-green' : item.total_change_value < 0 ? 'text-red' : ''">
          {{ item.total_change_value ? human_number(item.total_change_value) : '' }}
        </span>
      </template>
    </v-data-table>
    <v-alert v-if="!isSubscriber && items.length > 0" type="info" variant="tonal" class="mt-3">
      Showing 2 of {{ items.length }} results.
      <a href="/pricing" target="_blank">Subscribe</a> to view all global holdings data.
    </v-alert>
    <small>Source: Refinitiv</small>
  </div>
</template>

<script>
import api from '@/store/api'
import { useAppStore, useUserStore } from '@/store'
import FormattersMixin from '@/mixins/formatters'

export default {
  mixins: [FormattersMixin],

  props: {
    ownerCountry: { type: String, default: null }
  },

  data() {
    return {
      loading: false,
      excludeUs: false,
      items: [],
      headers: [
        { title: 'Stock Name', key: 'instrument_name' },
        { title: 'Ticker', key: 'ticker' },
        { title: 'Country', key: 'issuer_country' },
        { title: 'Exchange', key: 'exchange' },
        { title: 'Total Market Value', key: 'total_market_value' },
        { title: '# Owners', key: 'num_owners' },
        { title: 'Avg % Portfolio', key: 'avg_pct_portfolio' },
        { title: 'Net Change in Value', key: 'total_change_value' }
      ]
    }
  },

  computed: {
    isSubscriber() {
      const store = useUserStore()
      return store.isSubscriber || store.isProSubscriber || store.isEnterpriseSubscriber
    }
  },

  watch: {
    ownerCountry() { this.fetchData() },
    excludeUs() { this.fetchData() }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      const params = {}
      if (this.ownerCountry) params.owner_country = this.ownerCountry
      if (this.excludeUs) params.exclude_us = 'true'
      api.get('global_top_holdings', { params })
        .then(response => { this.items = response.data })
        .catch(error => {
          useAppStore().showNotification({ type: 'error', text: (error.response?.data) || error.message })
        })
        .finally(() => { this.loading = false })
    }
  }
}
</script>
